export let life = {
  mounted () {
    this.boxWidth = $(this.$refs.box).width()
  }
}
export let event = {}
export let watch = {}
